import { extractKeyValuePairs } from "./util";

/**
 * Utility function to extract operator and value from search strings like ">500", "<1000", "=200"
 * @param searchValue - The search value that may contain an operator
 * @returns Object with operator and numeric value, or null if parsing fails
 */
export function parseComparisonOperator(searchValue: string): {
  operator: string | null;
  value: string;
} {
  const match = searchValue.match(/^([><=]+)(.+)$/);
  if (match) {
    const [, operator, value] = match;
    return { operator, value };
  }
  return { operator: null, value: searchValue };
}

export function extractKeyedSearchTerms(
  search: string
): [{ key: string; value: string[] }[], string] {
  const keyValuePairsWithPositions = extractKeyValuePairs(search);

  const keyValuePairs = keyValuePairsWithPositions.map(({ key, value }) => ({
    key,
    value,
  }));

  // Construct the unmatched portion by excluding matched segments
  let unmatchedSearch = "";
  let currentIndex = 0;

  keyValuePairsWithPositions.forEach(({ start, end }) => {
    if (currentIndex < start) {
      unmatchedSearch += search.slice(currentIndex, start) + " ";
    }
    currentIndex = end;
  });

  // Append any remaining unmatched portion after the last match
  if (currentIndex < search.length) {
    unmatchedSearch += search.slice(currentIndex);
  }

  return [keyValuePairs, unmatchedSearch.trim()];
}
